// extracted by mini-css-extract-plugin
module.exports = {"container":"Toggle_container__N--tr"};